import React, { useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core'
import CleanerSchedule from '../../../components/common/CleanerSchedule'
import DaysWeek from '../../../components/common/DaysWeek'
import { dayNightValues, days, loadingContentForStaffAvailability, noOfSessions, timeSelectionArrayForDay, timeSelectionArrayForNight } from '../../../utils/constants'
import { useDispatch, useSelector } from 'react-redux'
import { getStaffs, getStaffsGenReg, selectPreferredStaff, setAdditionalComments, setAnalysisArray, setFrequencyShow, setHasTimeSelected, setNumberOfSessions, setRecurrenceRule, setRecurrenceRuleSoft, setRegularServiceArrays, setSelectedDuration, setSelectedService, setSelectedTimeRange, setSelectedTimeRangeForUIShow, setTimetimeRangeSelectionForDropDown } from '../../../redux/reducers/createOrderSlice'
import DropDownForDayNight from './DropDownForDayNight'
import DropDownForDurationsRegular from './DropDownForDurationsRegular'
import DropDownForSessions from './DropDownForSessions'
import { LocalizationProvider, DateCalendar, TimePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { getDayNumber } from '../../../utils/getDayNumbers'
import { Badge, TextField } from '@mui/material'
import dayjs from "dayjs";
import { changeTimeFromMioToNormal, convertHtmlTimeToMui, getNextISOString, getNextISOStringDynamic, getNextISOStringSameWeek, isBeforeApril1st2024 } from '../../../utils/createOrderCommonFunctions'
import { getDateTime } from '../../../utils/getDate'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import DropDownForTimeSelection from './DropDownForTimeSelection'
import { setLoadingContent } from '../../../redux/reducers/loadingSlice'
import { getMonthlyBlockDates } from '../../../redux/reducers/myOrdersSlice'
const RegularOrderService = () => {
  // Hooks call
  const dispatch = useDispatch()
  const navigate = useNavigate()

  // Stores
  const { recurrenceRule,
    timeSelected,
    additionalComments,
    selectedCategoryOption,
    selectedEndDate,
    selectedStartDate,
    selectedService,
    selectedDuration,
    preferredStaffs,
    selectedPreferredStaff,
    numberOfsessions,
    regularServiceArrays,
    hasStaffAvailable,
    selectedAddress,
    dayNightOptionsForUi,
    priceDetails,
    timeRangeSelectionForDropDown,
    staffAvailabilityArrayForRegular
  } = useSelector((state) => state.createOrderSlice)
  const { user, myprofile } = useSelector((state) => state.auth)
  const { companyBlockDates } = useSelector((state) => state.orders)
  // const prevDaysRef = useRef(recurrenceRule.days);


  // States
  const [frequency, setFrequency] = useState(0)
  const [selectedDays, setSelectedDays] = useState([])
  const [date, setDate] = useState(selectedStartDate ?? '')
  const [endValue, setEndValue] = useState('')
  const [selectTimeForScheduleList, setSelectTimeForScheduleList] = useState(false)
  const [dayNightOptions, setDayNightOptions] = useState([])
  const [error, setError] = useState(false)
  const [agreeTerms, setAgreeTerms] = useState(false)
  const durationsRegular = recurrenceRule?.timePreference?.includes('Day') ? [3, 4, 5, 6, 7, 8, 9] : [3, 4];

  // Functions

  const recurrenceRuleSet = (data) => {
    dispatch(setRecurrenceRule({ recurrenceRule: { ...recurrenceRule, ...data } }))
    setDate('')
  }
  const recurrenceRuleSetSoft = (data) => {
    dispatch(setRecurrenceRuleSoft({ recurrenceRule: { ...recurrenceRule, ...data } }))
  }


  const selectDays = (item) => {
    if (selectedDays?.includes(item?.value)) {
      let t = [...selectedDays]
      t.splice(t.indexOf(item?.value), 1)
      setSelectedDays([...t])
      recurrenceRuleSet({ days: [...t] })
    }
    else {
      setSelectedDays([...selectedDays, item?.value])
      recurrenceRuleSet({ days: [...selectedDays, item?.value] })
    }
  }

  const changeDuration = (e) => {
    if (!!selectedEndDate) {
      let startDate = new Date(selectedStartDate)
      startDate.setHours(startDate.getHours() + e.target.value)
      dispatch(setSelectedTimeRange({ selectedStartDate: selectedStartDate, selectedEndDate: startDate.toISOString() }))
      setEndValue(
        `${(startDate.getHours()) > 23
          ? (startDate.getHours()) - 24
          : (startDate.getHours())
        }:${startDate.getMinutes()}`
      );
    }
    dispatch(setSelectedDuration({ selectedDuration: e.target.value }))
  }

  const handleSessions = (data) => {
    dispatch(setNumberOfSessions({ numberOfsessions: data }))
    setSelectTimeForScheduleList(true)
  }
  const handlePreferredStaff = (item) => {
    if (item.isActive === 'inactive') {
      toast.error('This staff member is inactive, so you cannot select them.')
    }
    else {
      // Check if cleaner is already in the selected array
      const isSelected = selectedPreferredStaff.includes(item?.staffUserId);

      if (isSelected) {
        // If already selected, remove it

        const newArr = selectedPreferredStaff.filter((selectedId) => selectedId !== item?.staffUserId)
        dispatch(selectPreferredStaff(newArr))
      } else {
        // If not selected, add it to the array
        const newArr = [item?.staffUserId]
        if (newArr[0]) {
          dispatch(selectPreferredStaff(newArr))
        }
        else {
          dispatch(selectPreferredStaff([]))
        }

      }


      // dispatch(selectPreferredStaff(item?._id ? [item?._id] : []))
    }
  }

  const isWeekend = (date) => {
    const day = date.day();

    let blockDate = companyBlockDates?.map(item => item?.startDate)
    for (let day of blockDate) {
      if ((new Date(day).getDate() === new Date(date).getDate()) && (new Date(day).getMonth() === new Date(date).getMonth())) {
        return true
      }
    }
    return !selectedDays?.map(item => { return ((getDayNumber(item) - 1)) }).includes(day);
  };
  const weekday = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

  const rearrangeDays = (dayArray, chosenDay, indexNumber) => {
    // Find the index of the chosenDay in the array
    const index = dayArray.indexOf(weekday[chosenDay]);
    // Rearrange the array by pushing all elements before the chosenDay to the end
    const rearrangedArray = indexNumber > 0 ? dayArray : dayArray.slice(index);
    return rearrangedArray;
  }

  const createSchedulelist = () => {

    if (numberOfsessions) {
      const divider = (numberOfsessions > selectedDays?.length) ? Math.ceil(numberOfsessions / selectedDays?.length) : 1
      let newArray = [];
      for (let i = 0; i < ((weekday[new Date(selectedStartDate).getDay()] === recurrenceRule?.days[0]) ? divider : divider + 1); i++) {
        rearrangeDays(recurrenceRule?.days, new Date(selectedStartDate)?.getDay(), i)?.map((item, index) => {
          let arr = [...newArray];
          let newObj = {
            "serviceId": selectedService[0]?._id,
            "duration": selectedDuration,
            "position": newArray?.length + 1,
            "staff": "",


            "startDate": i === 0 ? getNextISOStringSameWeek((arr[arr?.length - selectedDays?.length]?.startDate) ?? selectedStartDate, item) : (recurrenceRule?.type === 'fortnight' ? getNextISOStringDynamic((arr[arr?.length - selectedDays?.length]?.startDate) ?? selectedStartDate, item, 14) : recurrenceRule?.type === 'month' ? getNextISOStringDynamic((arr[arr?.length - selectedDays?.length]?.startDate) ?? selectedStartDate, item, 28) : getNextISOString((arr[arr?.length - selectedDays?.length]?.startDate) ?? selectedStartDate, item)),


            "endDate": i === 0 ? getNextISOStringSameWeek((arr[arr?.length - selectedDays?.length]?.startDate) ?? selectedStartDate, item, selectedDuration) : recurrenceRule?.type === 'fortnight' ? getNextISOStringDynamic((arr[arr?.length - selectedDays?.length]?.startDate) ?? selectedStartDate, item, 14, selectedDuration) : recurrenceRule?.type === 'month' ? getNextISOStringDynamic((arr[arr?.length - selectedDays?.length]?.startDate) ?? selectedStartDate, item, 28, selectedDuration) : getNextISOString((arr[arr?.length - selectedDays?.length]?.startDate) ?? selectedStartDate, item, selectedDuration)
          }
          newObj["daysSelected"] = recurrenceRule?.days;
          newObj["selectedFrequency"] = recurrenceRule?.frequency;
          newObj["selectedTimePrefence"] = recurrenceRule?.timePreference;
          newArray.push(newObj);
        })
      }
      dispatch(setRegularServiceArrays({ regularServiceArrays: newArray?.filter((item, index) => index < numberOfsessions) }))
    }
  }
  const changeTime = (name, value) => {
    var [hours, minutes] = value.split(":")
    setEndValue(`${((Number(hours) + Number(selectedDuration)) > 23 ? ((Number(hours) + Number(selectedDuration)) - 24) : (Number(hours) + Number(selectedDuration)))}:${minutes}`)
    let existingDate = new Date(date)
    existingDate.setHours(parseInt(hours));
    existingDate.setMinutes(parseInt(minutes));
    let endTime = new Date(date)
    endTime.setHours(parseInt(Number(hours) + Number(selectedDuration)));
    endTime.setMinutes(parseInt(minutes));
    dispatch(setSelectedTimeRange({ selectedStartDate: existingDate.toISOString(), selectedEndDate: endTime }))
    dispatch(setHasTimeSelected({ timeSelected: !timeSelected }))
    setSelectTimeForScheduleList(true)
  }
  const gotoNextPage = () => {
    if (!agreeTerms) {
        toast.error("Please confirm that you understand the cleaning supplies policy.");
        return;
    }
    // if (!hasStaffAvailable) {
    //   setError(true)
    //   // toast.error("Please select all fields")
    // }
    // else 
    if (selectedEndDate && selectedService?.length) {
      navigate('/checkout')
    }
    else {
      toast.error("Please choose the time")
    }
  }
  const gettingStaffs = () => {
    dispatch(setLoadingContent(loadingContentForStaffAvailability))



    dispatch(getStaffsGenReg({
      values: {
        location: selectedAddress?.location,
        orderType: "Regular",
        svcStartDate: regularServiceArrays[0]?.startDate,
        svcEndDate: regularServiceArrays[
          regularServiceArrays?.length - 1
        ]?.endDate,
        staffNeeded: 1,
        preferredStaffs: selectedPreferredStaff,
        serviceArray: regularServiceArrays
      },
      dispatch: dispatch
    }))
  }
  const handleGenerate = () => {
    const result = [];
    const timeIntervals = recurrenceRule?.timePreference?.includes('Day') ?
      timeSelectionArrayForDay(+selectedDuration) : timeSelectionArrayForNight(+selectedDuration)    // for(let i=0; i<selectionArr.length; i++){

    const duration = { hours: selectedDuration, minutes: 0, seconds: 0 };

    for (let i = 0; i < timeIntervals.length; i++) {
      const startTime = timeIntervals[i];
      const endTime = {
        hours: startTime.hours + duration.hours,
        minutes: startTime.minutes + duration.minutes,
        seconds: startTime.seconds + duration.seconds,
      };
      result.push({ startTime, endTime, id: `timeRange-${i + 1}` });

    }
    if (result.length > 0) {
      dispatch(setTimetimeRangeSelectionForDropDown({ timeRangeSelectionForDropDown: result }))
    }

  }
  // UseEffects
  useEffect(() => {
    if (selectedCategoryOption.value === 7) {
      setFrequency(selectedCategoryOption.value)
      setSelectedDays(days?.map(item => item?.value))
      recurrenceRuleSetSoft({ frequency: selectedCategoryOption?.option, days: days?.map(item => item?.value) })
      dispatch(setFrequencyShow({ frequencyShow: selectedCategoryOption.value }))
    }
    else if (selectedCategoryOption.type === "fortnight") {
      setFrequency(1)
      setSelectedDays(recurrenceRule?.days ? recurrenceRule?.days : [])
      recurrenceRuleSetSoft({ frequency: selectedCategoryOption?.option, days: recurrenceRule?.days ? recurrenceRule?.days : [], type: selectedCategoryOption.type })
      dispatch(setFrequencyShow({ frequencyShow: 1 }))
    }
    else if (selectedCategoryOption.type === "month") {
      setFrequency(1)
      setSelectedDays(recurrenceRule?.days ? recurrenceRule?.days : [])
      recurrenceRuleSetSoft({ frequency: selectedCategoryOption?.option, days: recurrenceRule?.days ? recurrenceRule?.days : [], type: selectedCategoryOption.type })
      dispatch(setFrequencyShow({ frequencyShow: 1 }))

    }
    else {
      setFrequency(selectedCategoryOption.value)
      setSelectedDays(recurrenceRule?.days ? recurrenceRule?.days : [])
      recurrenceRuleSetSoft({ frequency: selectedCategoryOption?.option, days: recurrenceRule?.days ? recurrenceRule?.days : [] })
      dispatch(setFrequencyShow({ frequencyShow: selectedCategoryOption.value }))
    }
  }, [selectedCategoryOption])

  useEffect(() => {
    if (selectedStartDate && selectedEndDate && date) {
      let startDate = new Date(selectedStartDate)
      startDate.setDate(new Date(date).getDate())
      startDate.setMonth(new Date(date).getMonth())
      startDate.setFullYear(new Date(date).getFullYear())
      let endDate = new Date(selectedEndDate)
      endDate.setDate(new Date(date).getDate())
      endDate.setMonth(new Date(date).getMonth())
      endDate.setFullYear(new Date(date).getFullYear())
      dispatch(setSelectedTimeRange({ selectedStartDate: startDate.toISOString(), selectedEndDate: endDate.toISOString() }))
    }
  }, [date])

  useEffect(() => {
    if (recurrenceRule?.days && selectedStartDate && (selectedDays?.length === frequency) && selectTimeForScheduleList) {

      createSchedulelist()
    }
  }, [selectedDays, frequency, selectedStartDate, selectedEndDate, selectedDuration, numberOfsessions])

  useEffect(() => {
    if (
      selectedStartDate &&
      selectedEndDate &&
      selectedDuration &&
      regularServiceArrays &&
      regularServiceArrays?.length
    ) {
      gettingStaffs();
    }
  }, [

    selectedStartDate,
    selectedEndDate,
    selectedDuration,
    numberOfsessions,
    regularServiceArrays,
    selectedPreferredStaff
  ]);

  useEffect(() => {
    if (selectedStartDate) {
      document.getElementById('date-picker-regular').value = selectedStartDate
    }
  }, [selectedStartDate])

  useEffect(() => {
    handleGenerate()
  }, [selectedDuration])


  useEffect(() => {
    let startDate = selectedStartDate ? new Date(selectedStartDate) : new Date()
    startDate.setDate(startDate.getDate() + 2)
    startDate.setDate(1)
    let endDate = selectedStartDate ? new Date(selectedStartDate) : new Date()
    endDate.setDate(endDate.getDate() + 2)
    endDate.setDate(31)
    dispatch(getMonthlyBlockDates({
      currentPage: 1,
      limit: 31,
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString()
    }))
    if (selectedStartDate) {
      setDate(selectedStartDate)
    }
  }, [])

  // useEffect(() => {
  //   if (JSON.stringify(prevDaysRef.current) !== JSON.stringify(recurrenceRule.days)) {
  //     prevDaysRef.current = recurrenceRule.days; // Update previous value
  //     dispatch(setRegularServiceArrays({ regularServiceArrays: [] }))
  //   }
  // }, [recurrenceRule.days]);

  const handleMonthChange = (data) => {
    let endDate = new Date(data)
    endDate.setDate(31)
    dispatch(getMonthlyBlockDates({
      currentPage: 1,
      limit: 31,
      startDate: new Date(data).toISOString(),
      endDate: endDate.toISOString()
    }))
  }


  return (
    <>

      {selectedDays?.length !== 7 && <div className="day-wrap max-720">
        <DaysWeek selectDays={selectDays} selectedDays={selectedDays} error={error} />
      </div>}


      <div className="form-select-s max-720">
        <div className="row align-items-center">
          <div className="col-md-6">
            <DropDownForDayNight
              label={"Day/Night Session"}

              options={dayNightOptionsForUi}
              recurrenceRuleSet={recurrenceRuleSet}
              selectedDays={selectedDays}
              selectedService={selectedService}
              error={error}
            />
          </div>
          {/* <div className="form-select-s max-720"> */}
          {/* <div className="row"> */}
          <div className="col-md-6">
            <DropDownForDurationsRegular
              label={"Hours for each cleaning session?"}
              options={durationsRegular ?? []}
              onChange={changeDuration}
              optionsExtraText={`$${recurrenceRule?.timePreference?.includes('Day') ? (selectedService && selectedService[0]?.ratePerService) : (selectedService && selectedService[0]?.ratePerServiceNight)}/hr`}
              disableCondition={!recurrenceRule?.timePreference}
              error={error}
            />
          </div>
          {/* </div> */}
          {/* </div> */}
          <div className="col-md-6 numbb-dr">

            <DropDownForSessions
              label={"Number of Sessions"}
              options={noOfSessions}
              onChange={handleSessions}
              disableCondition={!selectedDuration}
              error={error}
            />
          </div>
        </div>
      </div>
      <div className="cleaer-schedul max-720">
        <p className='mb-0'>Select a date and time for your first session: *</p>
        {myprofile && myprofile?.preferredStaffs && myprofile?.preferredStaffs?.length ? <div className="d-flex align-items-center">

          <div className="d-flex align-items-center">
            <CleanerSchedule
              label={"Preferred Cleaner’s schedule or choose a date:"}
              tooltext="What is the size of your property"
            />
          </div>
        </div> : null}

        <div className="schedule-img-wrap  d-flex">
          {myprofile && myprofile?.preferredStaffs && myprofile?.preferredStaffs?.length > 0 && myprofile?.preferredStaffs?.map(cleaner => {
            return (
              <>
                <div className="schedule-single-img" style={{ border: `${selectedPreferredStaff[0] === cleaner?.staffUserId ? "2px solid #bb2026" : ""}` }} onClick={() => handlePreferredStaff(cleaner)}>
                  <div className="single-img-w">
                    <img
                      // src="/assets/images/2.png"
                      src={cleaner?.profileimageurl ?? "/assets/images/2.png"}
                      alt=""
                      className="rounded-circle"
                    />
                  </div>
                  <p>{cleaner?.fname}</p>

                  {cleaner?.isActive === "inactive" &&
                    <p style={{ backgroundColor: "#3c76cc", color: "#fff", padding: "1px 5px", borderRadius: "5%" }}>Inactive</p>}

                </div>
              </>
            )
          })}


          {myprofile && myprofile?.preferredStaffs && myprofile?.preferredStaffs?.length ?
            <div style={{ border: `${selectedPreferredStaff?.length === 0 ? "2px solid #bb2026" : ""}` }} className="schedule-gary d-flex align-items-center" onClick={() => handlePreferredStaff({})}>
              <p>Your Preferred Date</p>
            </div> : null}
        </div>
      </div>

      <div className="datepicker-wrap max-720">
        {user && <div className="ann-calender-wrap d-flex align-items-center justify-content-between">
          {(myprofile && myprofile?.preferredStaffs && myprofile?.preferredStaffs?.length && selectedPreferredStaff && selectedPreferredStaff?.length && selectedPreferredStaff[0]) ? <p p className="mb-0">Schedule base on <span className="colour-red">{myprofile?.preferredStaffs?.find(item => item?._id === selectedPreferredStaff[0])?.name}:</span></p> : null}
          <div className="ann-refresh">
            <FontAwesomeIcon icon={icon({ name: "arrows-rotate" })} />

          </div>
        </div>}
        <div className="row align-items-center">
          <div className="col-md-6">

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateCalendar
                onMonthChange={handleMonthChange}
                minDate={isBeforeApril1st2024() ? dayjs(new Date('2024-04-01T00:00:00.000')) : dayjs(new Date().setDate(new Date().getDate() + 2))}
                onChange={(newValue) => setDate(new Date(newValue).toISOString())}
                disabled={!numberOfsessions}
                value={selectedStartDate && dayjs(selectedStartDate)}
                id="date-picker-regular"
                renderInput={(params) => (
                  <TextField {...params} className={`!p-0`} />
                )}
                shouldDisableDate={isWeekend}
                slotProps={{
                  textField: {
                    readOnly: true,
                  },
                }}
              />
            </LocalizationProvider>
            {error ? !date && <p className='form-error-message'>This field is required</p> : null}

          </div>
          <div className="col-md-6">
            <div className="time-wrap">
              <div className="ann-calender-wrap">
                <p className="text-center">Timing Available *</p>
              </div>

              <div className="time-pick-wrap">
                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    disabled={!date}
                    value={selectedStartDate && dayjs(selectedStartDate)}
                    minutesStep={15}
                    onChange={(e) => changeTime('selectedStartDate', changeTimeFromMioToNormal(e))}
                    renderInput={(params) => <TextField {...params} />}
                    ampm={false}
                    minTime={recurrenceRule?.timePreference?.includes('Day') ? dayjs().set('hour', 8).set("minute", 0) : dayjs().set('hour', 18).set("minute", 0)}
                    maxTime={recurrenceRule?.timePreference?.includes('Day') ? dayjs().set('hour', 18 - selectedDuration).set("minute", 0) : dayjs().set('hour', (22 - selectedDuration)).set("minute", 0)}
                    slotProps={{
                      textField: {
                        readOnly: true,
                      },
                    }}
                  />
                </LocalizationProvider> */}

                <DropDownForTimeSelection
                  options={timeRangeSelectionForDropDown ?? []}
                  onChange={(val) => {
                    dispatch(setSelectedTimeRangeForUIShow(val))
                    changeTime('selectedStartDate', changeTimeFromMioToNormal(new Date(0, 0, 0, val?.startTime?.hours, val?.startTime?.minutes, val?.startTime?.seconds)?.toISOString()))
                  }
                  }
                  disableCondition={!date}
                  error={error}
                />
                {error ? !selectedStartDate && <p className='form-error-message'>This field is required</p> : null}


                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    disabled
                    value={selectedEndDate ? dayjs(selectedEndDate) : convertHtmlTimeToMui(endValue)}
                    renderInput={(params) => <TextField {...params} />}
                    ampm={false}
                    slotProps={{
                      textField: {
                        readOnly: true,
                      },
                    }}
                  />
                </LocalizationProvider> */}
              </div>
            </div>
          </div>
        </div>
        {regularServiceArrays && regularServiceArrays?.length > 0 &&
          <div className="select-sc">
            <h6>Selected Schedule</h6>
            <ul className="list-unstyled session-list">
              {regularServiceArrays?.map((item, index) => {
                return (
                  <>
                    <li style={{ color: `${(!staffAvailabilityArrayForRegular[index]?.isAvailable && selectedPreferredStaff?.length) ? '#bb2026' : ''}` }}>Session {index + 1} : <p style={{ color: `${(!staffAvailabilityArrayForRegular[index]?.isAvailable && selectedPreferredStaff?.length) ? '#bb2026' : ''}` }}>{getDateTime(item?.startDate, item?.endDate)}{(!staffAvailabilityArrayForRegular[index]?.isAvailable && selectedPreferredStaff?.length) ? ' *' : ''}</p></li>
                  </>
                )
              })}
            </ul>
            {(JSON.stringify(staffAvailabilityArrayForRegular).includes('false') && selectedPreferredStaff?.length) ? <p>*Due to unavailbility, preferred cleaner will be replace by another cleaner.</p> : null}

          </div>}
        <div className="remark-sec">

          <div className="textarea-bottom">
            <label >Additional instruction or remark:</label>
            <textarea className="form-control" value={additionalComments} onChange={(e) => dispatch(setAdditionalComments({ additionalComments: e.target.value }))}></textarea>
            <div className="form-check mt-2">
              <input
                type="checkbox"
                id="agreeTerms"
                className="form-check-input"
                checked={agreeTerms}
                onChange={(e) => setAgreeTerms(e.target.checked)}
              />
              <label htmlFor="agreeTerms" className="form-check-label additional-text mt-0">
                I understand that general / regular cleaning does not include cleaning supplies.
              </label>
            </div>
          </div>
          <div className="button-right">
            <button
              className="btn" onClick={() => gotoNextPage()}>
              Next
              <FontAwesomeIcon icon={icon({ name: "angle-right" })} />
            </button>
          </div>

        </div>
      </div >
    </>
  )
}

export default RegularOrderService